export default "__VITE_ASSET__6f6132c8__"